import styles from '../index.module.less'
import VTable from '@/vuetify_custom/v-table/v3'
import {getCustomerMonthSalaryTotalCompanyMonthSalaryInfoApi} from '@/views/fin/salaryadministration/service.js'
import { formattingNumber } from '@/libs/util.js'
import { VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from 'vuetify/lib'
export default {
    props: {
        id: {
            type:[String, Number]
        },
        params: {
            type: Object,
        }
    },
    data() {
        return {
            records:[],
            loading: false,
            expand: 0
        }
    },
    computed:{
        // ...mapGetters('async', {
        //     customer_types: 'customer_types',
        // }),
        headers() {
            return [
                {
                    text: '公司',
                  //   align: 'start',
                   
                    value: 'company_name',
                    fixed: 'left',
                    width: 120,
                    render: (v) => {
                        return <span style="font-size:0.75rem">{v}</span>
                    }
                },
                {
                    text: '发薪人数',
                    fixed: 'left',
                    align: 'center',
                    value: 'emp_num',
                    width: 80,
             
                },
                {
                    text: '资金准备',
                    // align: 'start',
                    fixed: 'left',
                    value: 'fund_preparation',
                    align: 'center',
                    type: 'money_field',
                    width: 112,
                    render: this.moneyRender
                },
                {
                    text: '税前工资',
                    // align: 'start',
                    fixed: 'left',
                    value: 'customer_salary',
                    align: 'center',
                    type: 'money_field',
                    width: 112,
                    render: this.moneyRender
                },
                {
                    text: '个税',
                    // align: 'start',
                    fixed: 'left',
                    value: 'individual_tax',
                    align: 'center',
                    type: 'money_field',
                    width: 100,
                    render: this.moneyRender
                },
                {
                    text: '税后工资',
                    // align: 'start',
                    value: 'after_tax_salary',
                    fixed: 'left',
                    align: 'center',
                    type: 'money_field',
                    width: 100,
                    render: this.moneyRender
                   // renderv:(_, __, target) => <span>{this.findCustomerType(target)}</span>
                },
                {
                    text: '社保',
                    // align: 'start',
                    // fixed: 'left',
                    align: 'center',
                    type: 'money_field',
                    value: 'social_security_total',
                    width: 80,
                    render: this.moneyRender
                },
                {
                    text: '公积金',
                    // align: 'start',
                    // fixed: 'left',
                    align: 'center',
                    type: 'money_field',
                    value: 'accumulation_fund_total',
                    width: 80,
                    render: this.moneyRender
                },
                {
                    text: '离职补偿&竞业实发',
                    // align: 'start',
                    // fixed: 'left',
                    align: 'center',
                    type: 'money_field',
                    value: 'after_tax_severance',
                    width: 100,
                    render: this.moneyRender,
                },
                {
                    text: '离职补偿个税',
                    // align: 'start',
                    // fixed: 'left',
                    align: 'center',
                    type: 'money_field',
                    value: 'severance_tax',
                    width: 80,
                    render: this.moneyRender
                },
                {
                    text: '养老单位缴费金额',
                    // align: 'start',
                    //
                    value: 'company_endowment_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '医疗单位缴费金额',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_medical_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '生育单位缴费金额',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_maternity_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '失业单位缴费金额',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_unemployment_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '工伤单位缴费金额',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_industrial_injury_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '大病单位缴费金额',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_supplementary_medical_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '养老个人',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'person_endowment_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '医疗个人',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'person_medical_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '失业个人',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'person_unemployment_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '补充医疗个人',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'person_supplementary_medical_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '公积金单位缴存额',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_accumulation_fund_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '子女教育',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'child_edu_deduct',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '住房贷款利息',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'housing_loan_deduct',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '住房租金',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'housing_rent_deduct',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '赡养老人',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'support_older_deduct',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '继续教育',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'continuing_edu_deduct',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '婴幼儿照护',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'baby_tend_deduct',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '单位社保',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_social_security_total',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '个人社保',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'person_social_security_total',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '单位公积金',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'company_accumulation_fund_amount',
                    width: 150,
                    render: this.moneyRender
                },
                {
                    text: '个人公积金',
                    // align: 'start',
                    align: 'center',
                    type: 'money_field',
                    value: 'person_accumulation_fund_amount',
                    width: 150,
                    render: this.moneyRender
                },
            ]
        }
    },
    watch: {
        id() {
            this.getList()
        }
    },
    created() {
        this.getList()
    },
    methods: {
        moneyRender(...arg) {
            // const field = arg[4]
            const value = arg[0] 
            return <div style="text-align:right">
                {formattingNumber(value, 2)}
            </div>
        },
        getList() {
          
            if (!this.id) {
                return 
            }
            this.loading = true
            getCustomerMonthSalaryTotalCompanyMonthSalaryInfoApi({
                id:this.id,
                customer_type: this.params.customer_type
            }).then(records => {
               this.records = records
            }).finally(() => {
                this.loading = false
            })
        }
    },
    
    render() {

        return <div class = {styles['search-bar-contain']}>
                <VExpansionPanels flat v-model={this.expand}> 
                    <VExpansionPanel>
                        <VExpansionPanelHeader>
                            汇总
                        </VExpansionPanelHeader>
                        <VExpansionPanelContent>      
                            <VTable
                                class={styles['summary-table']}
                                ref="table"
                                headers={this.headers}
                                desserts = {this.records}
                                loading={this.loading}
                            ></VTable>
                        </VExpansionPanelContent>
                    </VExpansionPanel>
                </VExpansionPanels>
        </div>
    }
}